import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { DeleteInstallable, DeleteInstallableVariables } from './__generated__/DeleteInstallable'
import {
  DeleteInstallableDefinition,
  DeleteInstallableDefinitionVariables
} from './__generated__/DeleteInstallableDefinition'

const DELETE_INSTALLABLE_MUTATION = gql`
  mutation DeleteInstallable($id: String!) {
    deleteInstallable(input: { id: $id }) {
      deleted
    }
  }
`

const DELETE_INSTALLABLE_DEFINITION_MUTATION = gql`
  mutation DeleteInstallableDefinition($installableId: String!) {
    deleteInstallableDefinitionV2(input: { installableId: $installableId }) {
      ... on InstallableDefinitionV2 {
        installableId
      }
      ... on InstallableErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteInstallable = () =>
  useMutation<DeleteInstallable, DeleteInstallableVariables>(DELETE_INSTALLABLE_MUTATION)

export const useDeleteInstallableDefinition = () =>
  useMutation<DeleteInstallableDefinition, DeleteInstallableDefinitionVariables>(DELETE_INSTALLABLE_DEFINITION_MUTATION)
